<template>
    <ModalComponent name="cambioPin" @close="close">
        <ContentOrLoading>
            <ValidationObserver class="w-100" tag="form" ref="observer" @submit.prevent="submit" v-if="!loading">
                <div class="form-group">
                    <label for="id_persona">ID</label>
                    <FormInput type="number" rules="required" name="id_persona" v-model="data.id_persona" disabled/>
                </div>
                <div class="form-group">
                    <FormInput label="Pin actual" type="number" name="pin" id="pin" rules="required"
                        v-model="data.pin_old" 
                    />
                </div>
                <div class="form-group">
                    <FormInput label="Nuevo Pin" type="number" name="pin" id="pin" rules="confirmed:confirmation|max:4"
                        v-model="data.pin_new" 
                    />
                </div>
                <div class="form-group">
                    <label for="password">Confirma el nuevo Pin </label>
        
                    <ValidationProvider name="pin" vid="confirmation">
                        <input type="number" 
                            id="pin_confirmation" placeholder="Pin" v-model="confirm_pin"
                        />
                    </ValidationProvider>
                </div>
                <div class="row">
                    <div class="col-12 d-flex justify-content-between">
                        <button type="submit" class="button" name="button" :disabled="loading">Enviar</button>
                    </div>
                </div>
            </ValidationObserver>
        </ContentOrLoading>
    </ModalComponent>
</template>

<script>
import ModalComponent from '@/components/backend/components/ModalComponent';

export default {

    props: ['loading', 'id_persona', 'pin_actual'],
    data() {
        return {
            data: {
                id_persona: this.id_persona,
                pin_old: this.pin_actual,
                pin_new: ''
            },
            confirm_pin: ''
        }
    },
    methods: {
        async submit() {
            const isValid = await this.$refs.observer.validate();  
            if(isValid) {
                this.$emit('cambiarPin', this.data);
                this.limpiarCampos();
            }
        },
        close() {
            this.limpiarCampos();
            this.$emit('close', 'cambioPin');
        },
        limpiarCampos() {
            this.data.pin_old = '';
            this.data.pin_new = '';
            this.confirm_pin = '';
        }
    },
    components: {
        ModalComponent
    }
}
</script>